<template>
  <thux-table
    :instance="instance"
    :instance-name="instanceName"
    :order-by-dict="orderByDict"
    :goBack="goBack"
    :list="list"
    :fieldName="fieldName"
    :fields="fields"
    :fields-column="fieldsColumn"
    :select-all="selectAll"
    :selected-list="selectedList"
    :get-local-selected-all="getLocalSelectedAll"
    :local-selected-list="localSelectedList"
    @check-all="checkAll"
    @check-none="checkNone"
    @set-selected-row="setSelectedRow"
    :show-checks="showChecks"
    :showEditButton="showEditButton"
    @change-status="changeInstanceStatus"
    @sort-changed="orderTable"
    @remove-order-by="removeOrderFromTable"
    @open-edit-form="$emit('open-edit-form', $event)"
  />
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { TYPES as INAIL_CODE_TYPES } from './store'
import { hasPerm } from '@/components/PermissionHelper'

import ThuxTableMixin from '../../../components/thux-table/ThuxTableMixin'
import ThuxTableChecksMixin from '../../../components/thux-table/thux-table-checks/ThuxTableChecksMixin'

export default {
  name: 'InailCodeTable',
  mixins: [ThuxTableMixin, ThuxTableChecksMixin],
  data () {
    return {
      fields: [
        {
          key: 'checks',
          label: this.$t('Checks')
        },
        {
          key: 'status',
          label: this.$t('Status'),
          tdClass: 'text-nowrap',
          thClass: 'text-nowrap',
          sortable: true,
          value: 'status'
        },
        {
          key: 'code',
          label: this.$t('Code'),
          type: 'text',
          thClass: 'text-nowrap',
          tdClass: 'text-nowrap',
          sortable: true,
          value: 'code'
        },
        {
          key: 'staff_type__name',
          label: this.$t('Staff typology'),
          tdClass: 'text-nowrap',
          thClass: 'text-nowrap',
          sortable: true,
          value: 'staff_type_name'
        },
        {
          key: 'action',
          label: this.$t('Actions'),
          tdClass: 'text-right text-nowrap',
          thClass: 'text-right text-nowrap'
        }
      ],
      fieldsColumn: ['status', 'code', 'staff_type__name']
    }
  },
  computed: {
    ...mapGetters({
      selectAll: INAIL_CODE_TYPES.GENERIC.organization.inailcode.LIST.GETTERS.selectAll,
      selectedList: INAIL_CODE_TYPES.GENERIC.organization.inailcode.LIST.GETTERS.selectedList
    }),
    showChecks () {
      return true
    },
    showEditButton () {
      return hasPerm('organization_inailcode_update')
    }
  },
  methods: {
    ...mapMutations({
      setList: INAIL_CODE_TYPES.GENERIC.organization.inailcode.LIST.MUTATIONS.setList,
      setSelectedList:
        INAIL_CODE_TYPES.GENERIC.organization.inailcode.LIST.MUTATIONS.setSelectedList,
      setSelectAll: INAIL_CODE_TYPES.GENERIC.organization.inailcode.LIST.MUTATIONS.setSelectAll
    }),
    ...mapActions({
      ...INAIL_CODE_TYPES.GENERIC.organization.inailcode.LIST.ACTIONS
    })
  }
}
</script>
